import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "item-select-modal" }
const _hoisted_2 = { class: "d-block text-center" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BModal, {
      show: _ctx.isShow,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShow) = $event)),
      "modal-id": 'bv-modal' + _ctx.windowId,
      title: `${_ctx.$t('itemSelectModal.select')} ${_ctx.entityTypeName}`,
      "hide-overlay": false,
      "no-footer": ""
    }, {
      "modal-title": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("itemSelectModal.select")) + " " + _toDisplayString(_ctx.entityTypeName), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("itemSelectModal.pleaseSelect")) + " " + _toDisplayString(_ctx.entityTypeName) + " " + _toDisplayString(_ctx.$t("itemSelectModal.fromTheList")), 1),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("select", {
              id: "SelectModal",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
              class: "form-select",
              "aria-label": "Select"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item[_ctx.valueField],
                  value: item[_ctx.valueField]
                }, _toDisplayString(item[_ctx.textField]), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selected]
            ])
          ])
        ]),
        _createVNode(_component_BButton, {
          block: "",
          class: "mt-3",
          onClick: _ctx.onSelect,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("itemSelectModal.select")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["show", "modal-id", "title"])
  ]))
}